import React, { useEffect, useState } from "react";
import { Grid, FormGroup, FormControlLabel, Switch, FormControl, TextField, Button, useTheme, useMediaQuery, Tooltip } from "@mui/material";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import Popup from "../../../Base/views/Popup";
import { AddEsicEpfoShortcutHelper } from "../../../FinanceSettings/helper/finance";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const OvertimeSelector = ({
  disabled,
  overtime,
  handleInputChange,
  handleOvertimeOptions,
  handleOverTimeChange,
  overtimeOptionData,
  temperrors,
}) => {
  return (
    <Grid container xs={12} md={12}>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          // marginTop: "1rem",
          paddingRight: "15px",
          paddingLeft: "15px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Overtime
        <div>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  disabled={disabled}
                  name="overtime_applicable_flag"
                  checked={overtime?.overtime_applicable_flag || false}
                  onChange={handleInputChange}
                />
              }
            />
          </FormGroup>
        </div>
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
        sx={{
          paddingRight: "15px",
          paddingLeft: "15px",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        {overtime?.overtime_applicable_flag && (
          <FormControl fullWidth>
            <SelectableSearch
              isOptionEqualToValue={(option, value) =>
                option.overtime_configuration_pk === value.overtime_configuration_pk
              }
              label={"Select Overtime Code"}
              endIcon={<Tooltip title={"Select the overtime rule that determines eligibility, rate and calculation method."} arrow>
                          <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "top", cursor: "pointer" }} />
                      </Tooltip>
              }
              fullWidth
              disabled={disabled}
              value={overtime?.overtime_configuration_pk}
              loading={handleOvertimeOptions}
              fieldLabel="alias_name"
              required={false}
              variantType="standard"
              name="overtime_configuration_pk"
              size="small"
              onChangeEvent={handleOverTimeChange}
              data={overtimeOptionData}
              {...(temperrors.overtime_configuration_pk && {
                error: true,
                helperText: temperrors.overtime_configuration_pk,
              })}
            />
          </FormControl>
        )}
      </Grid>
    </Grid>
  );
};


const AllowanceInput = ({
  label,
  flagName,          // e.g. "conveyance_allowance_flag"
  valueName = null,         // e.g. "conveyance_allowance"
  template,
  handleToggle,      // (fieldName: string) => void
  handleInputTemplate, // event => void
  errors = null,
  required = true,            // e.g. errors.conveyance_allowance
  isAllowed = true,             // condition check for toggle
  notAllowedMessage = "",
  buttonLabel = "", 
  setEmpRegNumber,  // {pf_no: "",esi_no: ""}
  currentData,
  empRegNumber,
  isCandidate = false, // only if pass from candidatePayroleTemplate as true
  disabled = false
}) => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const isToggledOn = template?.[flagName];
  const [showWarning, setShowWarning] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [epfNumber, setEpfNumber] = useState("");
  const [esicNumber, setEsicNumber] = useState("");
  const [uan, setUan] = useState(null);
  const [errorsField, setErrorsField] = useState("")
  const [type, setType] = useState("")
  const handleSwitchChange = () => {
      if (!isAllowed && !isToggledOn) {
        setShowWarning(true);
      }
      if (!isAllowed && isToggledOn) {
        setShowWarning(false);
      }
      handleToggle(flagName);
  };
  const handleAdd = (labelType) => {
    setOpenPopup(true)
    setType(labelType)
  }
  const handleAddEsicEpfo = () => {
    let errorMessage = "";

    if (type === "PF") {
      if (!epfNumber || epfNumber.trim() === "") {
        errorMessage = "EPF Number is required.";
      } else if (
        !epfNumber
          .toString()
          .match(/^[A-Z]{2}\/[A-Z]{3}\/\d{7}\/\d{3}\/\d{7}$/)
      ) {
        errorMessage = "Invalid EPF Number.";
      }
    }
    if (type === "ESIC") {
      if (!esicNumber || esicNumber.trim() === "") {
        errorMessage = "ESI Number is required.";
      } else if (!esicNumber.toString().match(/^\d{10}$/)) {
        errorMessage = "Invalid ESI Number.";
      }
    }
    if (errorMessage) {
      setErrorsField(errorMessage);
      return;
    }
    setErrorsField(""); 

    if (isCandidate) {
      setOpenPopup(false);
      setEmpRegNumber((prev) => ({
        ...prev,
        ...(type === "PF" && { pf_no: epfNumber }),
        ...(type === "ESIC" && { esi_no: esicNumber }),
        uan: uan,
      }));
      return;
    }

    AddEsicEpfoShortcutHelper({
      employee_fk: currentData?.employee_id,
      pf_no: epfNumber,
      esi_no: esicNumber,
      uan: uan,
     }).then((res) => {
      if (res?.data?.statuscode === 200) {
          setOpenPopup(false);
          setEmpRegNumber({
              pf_no: res?.data?.data?.[0]?.pf_no,
              esi_no: res?.data?.data?.[0]?.esi_no,
              uan: res?.data?.data?.[0]?.uan_no
          })
        }
    })
  }
  useEffect(() => {
    setEpfNumber(empRegNumber?.pf_no || "");
    setEsicNumber(empRegNumber?.esi_no || "");
    setUan(empRegNumber?.uan || null);
  }, [empRegNumber]);
  return (
    <>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          marginTop: ["PF Compliant Tag", "PF", "EPS"].includes(label) ? "0px" : "1rem",
          paddingRight: ["PF Compliant Tag", "PF", "EPS"].includes(label) ? "7px" : "15px",
          paddingLeft: ["PF Compliant Tag", "PF", "EPS"].includes(label) ? "0px" : "15px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {label}
        <div>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  onChange={handleSwitchChange}
                  checked={!!isToggledOn}
                  disabled={disabled}
                />
              }
            />
          </FormGroup>
        </div>
      </Grid>
      {label === "PF Compliant Tag" && isMdUp && (
        <Grid
          item
          md={6}
          sx={{
            marginTop: "1rem",
            paddingRight: "15px",
            paddingLeft: "15px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
          ></Grid>
      ) }

       {valueName && <Grid
          item
          xs={12}
          md={6}
          sx={{
            marginTop: "1rem",
            paddingRight: "15px",
            paddingLeft: "15px",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
          >
          {isToggledOn && (
          <FormControl fullWidth>
            <TextField
              size="small"
              type="number"
              onWheel={(e) => e.target.blur()}
              required={required}
              value={template?.[valueName] || ""}
              onChange={handleInputTemplate}
              variant="standard"
              fullWidth
              id={valueName}
              label=""
              name={valueName}
              autoComplete={valueName}
              {...(errors && {
                error: true,
                helperText: errors,
              })}
            />
          </FormControl>
      )}
        </Grid>}
        {showWarning && !isAllowed && (
          <Grid item xs={12} md={6}  p={label !== "PF" ? "10px 15px 0px 10px" : "0px"} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              {/* <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <WarningAmberIcon color="warning" sx={{ fontSize: 14 }} />
                <Typography
                  variant="caption"
                  sx={{ color: "#ffcb2e", fontSize: "0.75rem" }}
                >
                  {notAllowedMessage}
                </Typography>
              </Box> */}
              <Button
                variant="text"
                size="small"
                sx={{ fontSize: "0.75rem", minWidth: "auto", padding: "4px 6px" }}
                onClick={() => handleAdd(label)} 
              >
                {buttonLabel}
              </Button>
          </Grid>
        )}

      <Popup
          maxWidth="xs"
          fullWidth={true}
          title={`Add ${type === "PF" ? "EPF Number" : type === "ESIC" ? "ESI Number" : ""}`}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <Grid container spacing={2}>
            {type === "PF" && (
              <Grid key="name" item xs={12}>
                  <FormControl fullWidth >
                       <TextField
                          autoFocus
                          size="small"
                          value={epfNumber}
                          onChange={(e) => {setEpfNumber(e.target.value); setErrorsField("")}}
                          variant="outlined"
                          required
                          label="EPF Number"
                          name="pf_no"
                          placeholder="AB/XYZ/1234567/001/1234567"
                          sx={{
                            "& input::placeholder": {
                              color: "#B0B0B0",
                            },
                          }}
                          {...(errorsField && {
                            error: true,
                            helperText: errorsField,
                          })}
                        />
                  </FormControl>
              </Grid>
            )}
            { type === "ESIC" && (
              <Grid  item xs={12}>
                <FormControl fullWidth >
                    <TextField
                      autoFocus
                      size="small"
                      value={esicNumber}
                      onChange={(e) => {setEsicNumber(e.target.value); setErrorsField("")}}
                      variant="outlined"
                      required
                      label="ESI Number"
                      placeholder="1234567890"
                      name="esi_no"
                      sx={{
                      "& input::placeholder": {
                        color: "#B0B0B0",
                      },
                    }}
                    {...(errorsField && {
                            error: true,
                            helperText: errorsField,
                          })}
                    />
                </FormControl>
              </Grid>
          )}
           <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 1 }}>
              <Button
                variant="outlined"
                size="small"
                onClick={() => setOpenPopup(false)}
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                size="small"
                onClick={handleAddEsicEpfo}
              >
                Add
              </Button>
          </Grid>
          </Grid>
        </Popup>
    </>
  );
};

const getPeriodFromDate = (date) => {
   const month = new Date(date).getMonth() + 1;
  return (month >= 4 && month <= 9) ? "first" : "second";
   // first- April to September
   // second - October to March
};


const shouldDisableEsic = ({ esic, esic_modifiedon }) => {
  const currentPeriod = getPeriodFromDate(new Date());
  const modifiedPeriod = getPeriodFromDate(esic_modifiedon);
  const isEsicOn = !!esic;
  if (currentPeriod === "first") {
    return isEsicOn;
  }
  else if (currentPeriod === "second") {
    if(modifiedPeriod === "second" && isEsicOn) {
      return true
    }
    return false;
  }
  return false;
};

export { OvertimeSelector, AllowanceInput, getPeriodFromDate, shouldDisableEsic };
